
export const PASSWORD_MIN_LENGTH = 12;

export interface PasswordPolicyResult {
  ok: boolean;
  reason: string | null;
}

export function checkPasswordPolicy(pw: string): PasswordPolicyResult {
  if (pw.length < PASSWORD_MIN_LENGTH) {
    return { ok: false, reason: `Must be at least ${PASSWORD_MIN_LENGTH} characters with mixed character classes.` };
  }
  const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/].filter((re) => re.test(pw)).length;
  if (classes < 3) {
    return { ok: false, reason: `Must be at least ${PASSWORD_MIN_LENGTH} characters with mixed character classes.` };
  }
  return { ok: true, reason: null };
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function isWellFormedResetToken(token: string | undefined | null): boolean {
  if (!token) return false;
  return /^[A-Za-z0-9_-]{16,}$/.test(token);
}
